import Phaser from 'phaser';

import { shouldUseCanvasRenderer } from '@/shared/utils/browser';
import { getDevicePixelRatio } from '@/shared/utils/phaserCanvasSize';
import { BOUNCY_SUMS_SCENE_HEIGHT, BOUNCY_SUMS_SCENE_WIDTH } from './scenes/BouncySumsScene';
import { BOUNCY_SUMS_SCENES } from './scenes/sceneRegistry';

export function createGameConfig(parent: HTMLElement): Phaser.Types.Core.GameConfig {
	const devicePixelRatio = getDevicePixelRatio();

	return {
		type: shouldUseCanvasRenderer() ? Phaser.CANVAS : Phaser.AUTO,
		parent,
		width: Math.max(1, Math.round((parent.clientWidth || BOUNCY_SUMS_SCENE_WIDTH) * devicePixelRatio)),
		height: Math.max(1, Math.round((parent.clientHeight || BOUNCY_SUMS_SCENE_HEIGHT) * devicePixelRatio)),
		transparent: true,
		scene: BOUNCY_SUMS_SCENES,
		scale: {
			mode: Phaser.Scale.NONE,
		},
		audio: {
			disableWebAudio: false,
		},
		antialias: true,
		roundPixels: true,
	};
}
